import { SelectComponent } from "./Select.js";
import { jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from "react-hook-form";
//#region src/Select/SelectWrapper.tsx
/**
* @param controlled - использовать controlled-режим
* @param controlledClear - показать кнопку «Сбросить» внизу списка (очищает поле в "")
*/
const SelectWrapper = (props) => {
	const methods = useFormContext();
	if (props.controlled && !methods) throw new Error("Select must be used within a FormProvider");
	const handleClear = props.controlledClear && props.controlled ? () => {
		methods?.setValue(props.name, "", {
			shouldDirty: true,
			shouldValidate: true
		});
	} : props.onClear;
	return props.controlled ? /* @__PURE__ */ jsx(Controller, {
		name: props.name,
		control: methods.control,
		render: ({ field, fieldState }) => /* @__PURE__ */ jsx(SelectComponent, {
			...props,
			onChange: field.onChange,
			value: field.value,
			error: fieldState.error?.message,
			onClear: handleClear,
			onBlur: field.onBlur
		})
	}) : /* @__PURE__ */ jsx(SelectComponent, {
		...props,
		value: props.value,
		onChange: props.onChange
	});
};
//#endregion
export { SelectWrapper };

//# sourceMappingURL=SelectWrapper.js.map